import { exportProjectForecastingReport } from '@ubeya/shared/services/api';
import { generateForecastingReportCSV } from 'shared/utils/scheduling';

export const vatValueToPercentage = (vat) => (vat ? Math.round((vat - 1) * 10000) / 100 : 0);

export const vatValueFromPercentage = (vat) => (vat ? vat / 100 + 1 : 1);

export const charPad = (input, length, char, padFromLeft = true) => {
  if (padFromLeft) {
    return (Array(length + 1).join(char) + input).slice(-length);
  }
  return (input + Array(length + 1).join(char)).slice(0, length);
};

export const exportForecastingReport = async ({
  accountId,
  branchId,
  projectId,
  dateFormat,
  t,
  setForecastingReportLoadingModalOpen,
  formattingOptions,
  accountName
}) => {
  setForecastingReportLoadingModalOpen(true);
  const response = await exportProjectForecastingReport({ accountId, branchId, projectId });

  generateForecastingReportCSV({
    accountName,
    dateFormat,
    t,
    data: response.data || [],
    formattingOptions
  });

  //preparing the data to excel
  setTimeout(() => setForecastingReportLoadingModalOpen(false), 100);
};
